import type { CapitalisedLocale } from '../shared-types'

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLocale = defineStore('accountMappingLocale', () => {
  const supportedLocales = ref<CapitalisedLocale[]>([])

  function setSupportedLocales(locales: CapitalisedLocale[]): void {
    supportedLocales.value = locales
  }

  return {
    supportedLocales,
    setSupportedLocales,
  }
})
